import routes from '@/constants/routes';

export const stores = [
  {
    title: 'Apple',
    src: '/icons/seo/apple.svg',
    link: routes.APP_STORE,
  },
  {
    title: 'Google',
    src: '/icons/seo/google.svg',
    link: routes.GOOGLE_PLAY,
  },
  {
    title: 'Huawei',
    src: '/icons/seo/huawei.svg',
    link: routes.GOOGLE_PLAY,
  },
  {
    title: 'Mi',
    src: '/icons/seo/mi.svg',
    link: routes.GOOGLE_PLAY,
  },
];

export const backgrounds = [
  '/images/seo/banner/backgrounds/1.png',
  '/images/seo/banner/backgrounds/2.png',
  '/images/seo/banner/backgrounds/3.png',
  '/images/seo/banner/backgrounds/4.png',
  '/images/seo/banner/backgrounds/5.png',
];
